import React, { useState, useEffect } from 'react';
import "../custom.css";

export default function ListeningResult(props) {
	const [result, setResult] = useState(null);
	const ShowResultMarkers = [14];

	useEffect(() => {
		const { resultData } = props;
		setResult(resultData);
	}, []);

	const scoreClass = (score) => {
		let class_name = "color-danger";

		if (score > 30 && score <= 60) {
			class_name = "color-warning";
		} else if (score > 60) {
			class_name = "color-success";
		}

		return class_name;
	}
	
	const resultPercentage = () => {
		const { score, out_of } = result.score;
		return Math.round((score/out_of) * 100);
	}

	return (
		<>
			{result !== null &&
				<div className="visibility-visible">
					<div className='result-score-row result-score-row--inline d-flex flex-column flex-md-row align-items-center align-items-md-start justify-content-center gap-3'>
						<div className='score-content' style={{ flexDirection: "column", alignItems: "start" }}>
							<div className='gap-3 d-flex align-items-center'>
								<div
									className='circle'
									style={{
										'--percent': resultPercentage(),
										'--color': (resultPercentage() > 0 ? '#94C23C' : '#E0E0E0'),
										'--size': '110px',
										'--thickness': '4px',
									}}
								>
									<div className="circle-inner">
										{result.score.score}/{result.score.out_of}
									</div>
								</div>
								<ul className="result-markers result-category listening" style={{ flexDirection: "column", alignItems: "flex-start", background: "transparent", padding: 0 }}>
									<li className="listening-result-good">
										<span></span>Correct Answer
									</li>
									<li className="listening-result-bad">
										<span></span>Wrong Answer
									</li>
									<li className="listening-result-not-selected">
										<span></span>Not Selected But Correct Answer
									</li>
								</ul>
							</div>
							<div className="result-view-remarks d-flex justify-content-start w-100 mt-2">
								{props?.moreDetails }
							</div>
						</div>
					</div>
				</div>
			}
		</>
	);

	return (
		<>
			{result !== null &&
				<div className="pmw-outer-wrapper">
					<ul className="result-list">
						{Object.keys(result).map((item, i) => {
							return (
								<React.Fragment key={i}>
									{item !== 'html' &&
										<li key={i}>
											<h4 className="result-output">
												{/*<span className={result[item].score === 0 ? 'text-danger' : (result[item].score > 0 && result[item].score < result[item].out_of ? 'text-orange' : 'text-success')}>{result[item].score}/{result[item].out_of}</span>*/}
												<span className={scoreClass(result[item].score)}>{result[item].score}/{result[item].out_of}</span>
											</h4>
											<h3>{result[item].label}</h3>
										</li>
									}
								</React.Fragment>
							)
						})}
					</ul>

					{ShowResultMarkers.includes(props.subcategoryId) &&
						<ul className="result-markers result-category">
							<li className="good">
								<span></span>Correct Answer
							</li>
							<li className="not-selected">
								<span></span>Not selected but correct answer
							</li>
							<li className="bad">
								<span></span>Wrong Answer
							</li>
						</ul>
					}
				</div>
			}
		</>	
	);
}
